import React, { useEffect, Fragment } from "react";
import { useSelector, useDispatch } from "react-redux";
import { initializeSpecialist } from "~/redux/modules/specialist/auth";
import { initializeAdmin } from "~/redux/modules/admin/auth";
import {
  getSpecialist,
  getNotification,
  getQuestion,
  getHelp,
} from "~/redux/modules/admin/data";
import {
  getPrefectures,
  getBusinesses,
  getContacts,
  getCategories,
} from "~/redux/modules/master";
import { RootState } from "~/redux/rootReducer";

const SpecialistEffect: React.VFC = () => {
  const dispatch = useDispatch();

  // 認証情報
  const isInit = useSelector((state: RootState) => state.specialistAuth.isInit);
  useEffect(() => {
    isInit === false && dispatch(initializeSpecialist());
  }, [isInit]);

  return null;
};

const AdminEffect: React.VFC = () => {
  const dispatch = useDispatch();

  // 認証情報
  const isInit = useSelector((state: RootState) => state.adminAuth.isInit);
  const login = useSelector((state: RootState) => state.adminAuth.login);
  useEffect(() => {
    isInit === false && dispatch(initializeAdmin());
  }, [isInit]);

  // 専門家データ 取得
  const isSpecialistInit = useSelector(
    (state: RootState) => state.adminData.isSpecialistInit
  );
  useEffect(() => {
    if (isSpecialistInit === false && login === true) {
      dispatch(getSpecialist());
    }
  }, [isSpecialistInit, login]);

  // 通知データ 取得
  const isNotificationInit = useSelector(
    (state: RootState) => state.adminData.isNotificationInit
  );
  useEffect(() => {
    if (isNotificationInit === false && login === true) {
      dispatch(getNotification());
    }
  }, [isNotificationInit, login]);

  // ヘルプデータ 取得
  const isHelpInit = useSelector(
    (state: RootState) => state.adminData.isHelpInit
  );
  useEffect(() => {
    if (isHelpInit === false && login === true) {
      dispatch(getHelp());
    }
  }, [isHelpInit, login]);

  // 会話データ 取得
  const isQuestionInit = useSelector(
    (state: RootState) => state.adminData.isQuestionInit
  );
  useEffect(() => {
    if (isQuestionInit === false && login === true) {
      dispatch(getQuestion());
    }
  }, [isQuestionInit, login]);

  return null;
};

const MasterEffect: React.VFC = () => {
  const dispatch = useDispatch();

  // 都道府県データ 取得
  const isPrefectureInit = useSelector(
    (state: RootState) => state.master.isPrefectureInit
  );
  useEffect(() => {
    isPrefectureInit === false && dispatch(getPrefectures());
  }, [isPrefectureInit]);

  // 業態データ 取得
  const isBusinessInit = useSelector(
    (state: RootState) => state.master.isBusinessInit
  );
  useEffect(() => {
    isBusinessInit === false && dispatch(getBusinesses());
  }, [isBusinessInit]);

  // 連絡方法データ 取得
  const isContactInit = useSelector(
    (state: RootState) => state.master.isContactInit
  );
  useEffect(() => {
    isContactInit === false && dispatch(getContacts());
  }, [isContactInit]);

  // ノートカテゴリ 取得
  const isCategoryInit = useSelector(
    (state: RootState) => state.master.isCategoryInit
  );
  useEffect(() => {
    isCategoryInit === false && dispatch(getCategories());
  }, [isCategoryInit]);

  return null;
};

const InitializeEffect: React.VFC = () => {
  return (
    <Fragment>
      <SpecialistEffect />
      <AdminEffect />
      <MasterEffect />
    </Fragment>
  );
};
export default InitializeEffect;
